module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_8023.8b527668.png";